import React, {useCallback} from 'react';
import useConstant from 'use-constant';
import {useAsync} from 'react-async';
import awesomeDebouncePromise from 'awesome-debounce-promise';
import useAutosuggest from '@stencil/use-autosuggest';
// import {useCombobox as useAutosuggest} from 'downshift';

const DEBOUNCE_TIMEOUT = 250;

// const ListElement = React.memo(props => <div>{props.children}</div>);
// const InputElement = React.memo(props => <input {...props} />);
// const itemElementDefault = React.memo(item => <div>{item.n}</div>);

const ListElement = props => <div>{props.children}</div>;
const InputElement = props => <input {...props} />;
const itemElementDefault = item => <div>{item.n}</div>;

const onItemSelectionDefault = change => {};
const itemToStringDefault = item => item.n;
const massageDataDefault = items => items;

const Autosuggest = props => {
  const {
    initialInputValue = '',
    placeholder = '',
    onItemSelection = onItemSelectionDefault,
    itemToString = itemToStringDefault,
    itemElement = itemElementDefault,
    getUrl,
    rf,
    Input = InputElement,
    List = ListElement,
    massageData = massageDataDefault,
    onInputValueChange = () => {},
    resetOnInputBlur = true,
    renderWhenListingNotThere = <></>,
    renerInitailView = <></>,
    onShowInitialPage = false,
    cursor,
    setStopCursorUpdate,
    setCursorResult,
    onEnterPress
  } = props;

  // const [displayOverlay, setDisplayOverlay] = useState(false);

  // const toggleOverlay = flag => {
  //   setDisplayOverlay(flag);
  // };

  const fetchVoyagerLocationSuggestions = useCallback(
    async ({inputValue, rf}, {signal}) => {
      const fetchVoyagerUrlForInput = getUrl(inputValue, rf);

      if (!inputValue) {
        return [];
      }
      // const ret = { "predictions": [{ "description": "Bangalore, Karnataka, India", "loc_type": "city", "matched_substrings": [{ "length": 5 }], "place_id": "ChIJbU60yXAWrjsR4E9-UejD3_g", "reference": "ChIJbU60yXAWrjsR4E9-UejD3_g", "region": "bengaluru", "structured_formatting": { "main_text": "Bangalore", "secondary_text": "Karnataka, India" }, "terms": [{ "offset": 0, "value": "Bangalore" }, { "offset": 11, "value": "Karnataka" }, { "offset": 22, "value": "India" }], "types": ["locality", "political", "geocode"] }, { "description": "Bangalore Railway Station Back Gate, M.G. Railway Colony, Majestic, Bengaluru, Karnataka", "loc_type": "landmark", "matched_substrings": [{ "length": 5 }], "place_id": "ChIJx73smxsWrjsR7eKL6n2eOP0", "reference": "ChIJx73smxsWrjsR7eKL6n2eOP0", "region": "majestic", "structured_formatting": { "main_text": "Bangalore Railway Station Back Gate", "secondary_text": "M.G. Railway Colony, Majestic, Bengaluru, Karnataka" }, "terms": [{ "offset": 0, "value": "Bangalore Railway Station Back Gate" }, { "offset": 37, "value": "M.G. Railway Colony" }, { "offset": 58, "value": "Majestic" }, { "offset": 68, "value": "Bengaluru" }, { "offset": 79, "value": "Karnataka" }], "types": ["premise", "geocode"] }, { "description": "Bangarapet, Karnataka, India", "loc_type": "city", "matched_substrings": [{ "length": 5 }], "place_id": "ChIJu4YuxDfprTsRHSqs7ubXIaw", "reference": "ChIJu4YuxDfprTsRHSqs7ubXIaw", "region": "bangarapet", "structured_formatting": { "main_text": "Bangarapet", "secondary_text": "Karnataka, India" }, "terms": [{ "offset": 0, "value": "Bangarapet" }, { "offset": 12, "value": "Karnataka" }, { "offset": 23, "value": "India" }], "types": ["locality", "political", "geocode"] }, { "description": "Bangalore international airport, Hunachur, Karnataka, India", "loc_type": "airport", "matched_substrings": [{ "length": 5 }], "place_id": "ChIJz2E4UUUdrjsRqLNQsZ45je0", "reference": "ChIJz2E4UUUdrjsRqLNQsZ45je0", "region": "hunachur", "structured_formatting": { "main_text": "Bangalore international airport", "secondary_text": "Hunachur, Karnataka, India" }, "terms": [{ "offset": 0, "value": "Bangalore international airport" }, { "offset": 33, "value": "Hunachur" }, { "offset": 43, "value": "Karnataka" }, { "offset": 54, "value": "India" }], "types": ["airport", "point_of_interest", "establishment"] }, { "description": "Bangali square, Bengali Square, Goyal Nagar, Tilak Nagar, Indore, Madhya Pradesh, India", "loc_type": "landmark", "matched_substrings": [{ "length": 5 }], "place_id": "ChIJL31H3SLjYjkR8fA_ynCL5ig", "reference": "ChIJL31H3SLjYjkR8fA_ynCL5ig", "region": "indore", "structured_formatting": { "main_text": "Bangali square", "secondary_text": "Bengali Square, Goyal Nagar, Tilak Nagar, Indore, Madhya Pradesh, India" }, "terms": [{ "offset": 0, "value": "Bangali square" }, { "offset": 16, "value": "Bengali Square" }, { "offset": 32, "value": "Goyal Nagar" }, { "offset": 45, "value": "Tilak Nagar" }, { "offset": 58, "value": "Indore" }, { "offset": 66, "value": "Madhya Pradesh" }, { "offset": 82, "value": "India" }], "types": ["point_of_interest", "establishment"] }], "status": "OK" };
      const res = await fetch(fetchVoyagerUrlForInput, {signal});
      if (!res.ok) throw new Error(res.statusText);
      const ret = await res.json();
      if (ret.predictions && ret.predictions) {
        return ret.predictions;
      }
    },
    [getUrl],
  );

  const debouncedVoyagerFetchPromise = useConstant(() =>
    awesomeDebouncePromise(fetchVoyagerLocationSuggestions, DEBOUNCE_TIMEOUT),
  );

  // const debouncedVoyagerFetchPromise = useConstant(() => fetchVoyagerLocationSuggestions);

  const inputRef = React.useRef(null);
  // const [menuHeight, setMenuHeight] = React.useState(null);

  // React.useEffect(() => {
  //   if (inputRef.current && isOpen) {
  //     const distanceBtwInputAndWindowBottom =
  //       window.innerHeight -
  //       (inputRef.current.getBoundingClientRect().y + inputRef.current.offsetHeight);

  //     const proportionalDistance = distanceBtwInputAndWindowBottom / window.innerHeight;
  //     const percentageDistance = proportionalDistance * 100;
  //     const factorOfReductionForMenuHeight = percentageDistance * 0.625;

  //     const menuHeight = factorOfReductionForMenuHeight;

  //     setMenuHeight(menuHeight);
  //   }
  // }, [isOpen]);
  const {
    propGetters: {getInputProps, getMenuProps, getItemProps, getRootProps, inputHandleBlur, getLabelProps},
    state: {isOpen, inputValue},
  } = useAutosuggest({
    itemToString,
    initialInputValue,
    onInputValueChange,
    onShowInitialPage,
    onSelectedItemChange(changes) {
      onItemSelection(changes.selectedItem);
    },
    resetOnInputBlur,
  });

  const {data: items = [], isPending = false, isRejected = false, error = null} = useAsync({
    promiseFn: debouncedVoyagerFetchPromise,
    watch: inputValue,
    inputValue,
    rf
  });

  const itemsArr = massageData(items);

  React.useEffect(() => {
    if (inputValue?.length && !itemsArr?.length) {
      setCursorResult(-1)
    }
  }, [itemsArr, inputValue])

  React.useEffect(() => {
    if (itemsArr?.length && cursor === itemsArr?.length - 1) {
      setStopCursorUpdate(true)
    }
  }, [itemsArr, cursor])

  React.useEffect(() => {
    if (onEnterPress) {
      if (inputValue?.length && itemsArr?.length) {
        const selectedItem = itemsArr[cursor]
        onItemSelection(selectedItem)
        setStopCursorUpdate(false)
        setCursorResult(-1)
      }
      inputHandleBlur({resetInput: true})
    }
  }, [onEnterPress])

  const GetListingCard = ({item, index}) => {
    const fieldRef = React.useRef<HTMLInputElement>(null);
    React.useEffect(() => {
      if (fieldRef.current) {
        if (cursor === index) {
          fieldRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          })
        }
      }
    }, [cursor]); 
    return (
      <div
        style={{background: cursor === index ? '#eef4fd' : 'initial'}}
        key={item._id || index}
        {...getItemProps({
          item,
          index,
        })}
        ref={fieldRef}
        >
         {itemElement(item)}
      </div>
    )
  }

  return (
    <div {...getRootProps()}>
      <Input
        autoFocus
        name="autosuggest"
        type="text"
        {...getInputProps({
          ref: inputRef,
          placeholder
        })}
      />
      <List>
        <div {...getMenuProps()}>
          {!itemsArr?.length ? renerInitailView : null}
          {(isOpen &&
            itemsArr.map((item, index) => {
              return <GetListingCard item={item} index={index} />
            })) ||
            renderWhenListingNotThere}
        </div>
      </List>
    </div>
  );
};

export default React.memo(Autosuggest);
